<template>
  <div class="pay">
    <div @click="type('online')" :class="[selected=='online'?'active':'','paytype']">
      在线支付
    </div>
    <div @click="type('banktransfer')" :class="[selected=='banktransfer'?'active':'','paytype']">
      银行付款
    </div>
    <div class="submit" @click="ensure">
      确认
    </div>
  </div>
</template>
<style scoped lang="less">
  .pay {
    padding: 20px 18px;
    .paytype {
      height: 42px;
      line-height: 42px;
      color:#949494;
      font-size: 14px;
      background:url(../assets/image/order/d_check.png) 95% center no-repeat;
      background-size:14px auto;
      padding-left: 14px;
      border:1px solid #e0e0e0;
      margin-bottom: 10px;
      &.active {
        background:url(../assets/image/order/d_checked.png) 95% center no-repeat;
        background-size:14px auto;
      }
    }
    .submit {
      margin-top: 30px;
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      background-color: #2cb9e7;
      color: #ffffff;
      font-size: 16px;
    }
  }
</style>
<script>

    export default{
        data(){
            return{
                selected: this.$store.state.paymentType
            }
        },
        components:{

        },
        created() {

        },
        methods: {
          type(_type) {
            this.selected = _type;
          },
          ensure() {
            console.log(this.selected);
            this.$store.commit('setPayType',this.selected);
            this.$router.push('/SubmitOrder');
          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/PayType.vue